import { Link, useParams } from "react-router-dom";
import { Leaf, Home, BookOpen } from "lucide-react";

export default function ClientLayout({ children, dietician, clientName }) {
  const { token, nameSlug = "client" } = useParams();
  const base = `/${nameSlug}/${token}`;
  return (
    <div className="min-h-screen" data-testid="client-layout">
      <header className="sticky top-0 z-30 bg-[hsl(var(--brand-cream))]/85 backdrop-blur-xl border-b border-[hsl(var(--brand-border))]">
        <div className="max-w-5xl mx-auto px-5 md:px-8 py-4 flex items-center justify-between">
          <Link to={base} className="flex items-center gap-2" data-testid="client-logo-link">
            <div className="w-8 h-8 rounded-full bg-[hsl(var(--brand-sage))] text-white grid place-items-center">
              <Leaf className="w-4 h-4" />
            </div>
            <div>
              <div className="font-display text-lg leading-none">Nourish</div>
              <div className="text-[10px] tracking-[0.25em] uppercase text-[hsl(var(--brand-muted))] mt-0.5">
                {dietician?.name || "Dt. Amisha Kaushal"}
              </div>
            </div>
          </Link>
          <nav className="flex items-center gap-1">
            <Link to={base} className="px-3 py-2 text-sm rounded-md hover:bg-[hsl(var(--brand-cream-deep))] flex items-center gap-1.5" data-testid="client-nav-home">
              <Home className="w-4 h-4" /> <span className="hidden sm:inline">Home</span>
            </Link>
            <Link to={`${base}/recipes`} className="px-3 py-2 text-sm rounded-md hover:bg-[hsl(var(--brand-cream-deep))] flex items-center gap-1.5" data-testid="client-nav-recipes">
              <BookOpen className="w-4 h-4" /> <span className="hidden sm:inline">Recipes</span>
            </Link>
          </nav>
        </div>
      </header>
      <main>{children}</main>
      <footer className="mt-24 py-10 border-t border-[hsl(var(--brand-border))] bg-[hsl(var(--brand-cream))]">
        <div className="max-w-5xl mx-auto px-5 md:px-8 text-center">
          <div className="font-display text-2xl text-[hsl(var(--brand-ink))]">{dietician?.name || "Dt. Amisha Kaushal"}</div>
          <div className="text-sm text-[hsl(var(--brand-muted))] mt-1">
            {dietician?.phone || "+91 98729 52869"} · Nourish
          </div>
          {clientName ? (
            <div className="font-serif-italic text-[hsl(var(--brand-muted))] mt-4 text-sm">
              — Prepared with care for {clientName} —
            </div>
          ) : null}
        </div>
      </footer>
    </div>
  );
}
